/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils')
    .factory('Favicon', function () {
        let originalUrl;
        let url;

        return {
            storeOriginalUrl: function (param) {
                originalUrl = param;
            },
            setUrl: function (param) {
                url = param;
            },
            getUrl: function () {
                return url;
            },
            revertOriginalUrl: function () {
                url = originalUrl;
            }
        };

    });


